import { render, staticRenderFns } from "./BaseConfirmWithAvatar.vue?vue&type=template&id=262ab718&scoped=true&"
import script from "./BaseConfirmWithAvatar.vue?vue&type=script&lang=ts&"
export * from "./BaseConfirmWithAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./BaseConfirmWithAvatar.vue?vue&type=style&index=0&id=262ab718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262ab718",
  null
  
)

export default component.exports